import React from 'react';
import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import { header } from './__data';

const Header = () => {
  // const classes = useStyles();

  return (
    <>
      <Grid style={{padding: '5rem 2rem'}}>
        <CardMedia
          alt={header[0].alt}
          component="img"
          image={header[0].img}
          object-fit
          title={header[0].title}
        />
        <CardMedia
          alt={header[1].alt}
          component="img"
          image={header[1].img}
          object-fit
          title={header[1].title}
        />
      </Grid>
    </>
  );
}

export default Header;
